<template>
  <el-dialog
    title="服务评价"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
    @open="opened"
  >
    <div v-if="comment">
      <dl>
        <dt>评价人：</dt>
        <dd>{{ comment.user_name }}（{{ comment.user_mobile }}）</dd>
      </dl>
      <dl>
        <dt>总体满意度：</dt>
        <dd>{{ comment.rate }}星（满分10星）</dd>
      </dl>
      <dl>
        <dt>技术能力：</dt>
        <dd>{{ comment.rate1 }}星（满分10星）</dd>
      </dl>
      <dl>
        <dt>沟通能力：</dt>
        <dd>{{ comment.rate2 }}星（满分10星）</dd>
      </dl>
      <dl>
        <dt>讲解及建议：</dt>
        <dd>{{ comment.rate3 }}星（满分10星）</dd>
      </dl>
      <dl>
        <dt>报告质量：</dt>
        <dd>{{ comment.rate4 }}星（满分10星）</dd>
      </dl>
      <dl>
        <dt>服务水平：</dt>
        <dd v-if="comment.rate5 == 1">领先平均水平</dd>
        <dd v-else-if="comment.rate5 == 2">低于平均水平</dd>
        <dd v-else-if="comment.rate5 == 3">处于平均水平</dd>
      </dl>
      <dl>
        <dt>其他建议：</dt>
        <dd>
          {{ comment.desc || '无' }}
        </dd>
      </dl>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    comment: Object,
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
  created() {},
  methods: {
    opened() {},
  },
}
</script>

<style scoped>
dl {
  display: flex;
}

dl dt {
  width: 90px;
  min-width: 90px;
}
</style>